import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LayoutButtons from "./LayoutButtons";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2)
  }
}));

const LayoutFooter = ({
  className,
  padding = 1,
  buttons = [],
  buttonGroupProps,
  buttonProps
}) => {
  const classes = useStyles({
    padding
  });

  if (!buttons.length) {
    return false;
  }

  return React.createElement("footer", {
    className: className || classes.root
  }, buttons && React.createElement(LayoutButtons, {
    buttons: buttons,
    buttonGroupProps: buttonGroupProps,
    buttonProps: buttonProps
  }));
};

export default LayoutFooter;